import React, { useState, useEffect } from 'react'
import { useStore } from '../../StateProvider'
import { TierForm } from '../TierForm/TierForm'
import { useTranslation } from 'react-i18next'
import {
  additionalFldValues,
  filterByTier,
  getTextByLang
} from '../ExternalFields'
import { Page } from '../../ui/Page/Page'

export const Tier1Register = ({
  onSignUp
}) => {
  const { t } = useTranslation()
  const [{
    whitelabel,
    form,
    form: { accId }
  }] = useStore()
  const { customTexts, extFields } = whitelabel
  const [isLoading, setIsLoading] = useState(false)
  const {
    alreadyExistsSameError,
    alreadyExistsDiffError,
    loginExistsError,
    alreadyExistsSameExpiredError
  } = form[accId]

  const fldsDescriptionList = filterByTier(1)(extFields)

  useEffect(() => {
    if (alreadyExistsSameError || alreadyExistsDiffError || loginExistsError || alreadyExistsSameExpiredError) {
      setIsLoading(false)
    }
  }, [alreadyExistsSameError, alreadyExistsDiffError, loginExistsError, alreadyExistsSameExpiredError])

  const onSubmit = () => {
    setIsLoading(true)
    return onSignUp(additionalFldValues(form[accId])(fldsDescriptionList))
  }

  const pageTitle = getTextByLang(
    'createAccountTitle',
    customTexts,
    t('createAccountForm.formTitle')
  )

  const buttonName = getTextByLang(
    'createAccountButtonText',
    customTexts,
    t('createAccountForm.signup')
  )

  return (
    <Page caption={pageTitle} text={t('createAccount.allRequired')}>
      <TierForm
        isLoadingSubmit={isLoading}
        onSubmit={onSubmit}
        buttonName={buttonName}
      />
    </Page>
  )
}
